import { render, staticRenderFns } from "./kpiPage.vue?vue&type=template&id=1d945c71&scoped=true"
import script from "./kpiPage.vue?vue&type=script&lang=js"
export * from "./kpiPage.vue?vue&type=script&lang=js"
import style0 from "./kpiPage.vue?vue&type=style&index=0&id=1d945c71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d945c71",
  null
  
)

export default component.exports